import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, ArrowLeft, Loader2, Link as LinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { AuthLayout } from '../components/AuthLayout';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setMessage(t('auth.forgotPassword.successMessage'));
      setEmail('');
    } catch (err) {
      setError(err.response?.data || t('auth.forgotPassword.errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={t('auth.forgotPassword.title')}
      subtitle={t('auth.forgotPassword.subtitle')}
    >
      {!message ? (
        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="p-4 bg-red-50 border border-red-100 text-red-600 rounded-xl text-sm font-medium animate-shake">
              {error}
            </div>
          )}

          <Input
            label={t('auth.forgotPassword.emailLabel')}
            id="email"
            name="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('auth.forgotPassword.emailPlaceholder')}
            icon={<Mail className="w-5 h-5" />}
          />

          <Button
            type="submit"
            disabled={loading}
            className="w-full"
            size="lg"
            rightIcon={!loading && <LinkIcon className="w-5 h-5" />}
          >
            {loading ? t('auth.forgotPassword.sendingButton') : t('auth.forgotPassword.sendButton')}
          </Button>

          <Link
            to="/login"
            className="flex items-center justify-center text-slate-500 hover:text-slate-700 text-sm font-bold transition-colors group"
          >
            <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" />
            {t('auth.forgotPassword.backToLogin')}
          </Link>
        </form>
      ) : (
        <div className="bg-teal-50 border-2 border-teal-100 rounded-3xl p-8 text-center animate-scaleIn">
          <div className="w-20 h-20 bg-teal-500 rounded-full flex items-center justify-center text-white mx-auto mb-6 shadow-lg shadow-teal-500/20">
            <Mail className="w-10 h-10" />
          </div>
          <h3 className="text-2xl font-display font-bold text-slate-900 mb-4">Check Your Inbox</h3>
          <p className="text-slate-600 mb-8 leading-relaxed">
            {message}
          </p>
          <Button onClick={() => navigate('/login')} className="w-full" size="lg">
            Back to Login
          </Button>
        </div>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
